import angular from 'angular'

import { VD_CLASSES } from '../../constants'

const renderSplashElement = ({
  dismissible,
  contentTemplatePath,
  scrollable,
}) =>
  `<vd-splash template-path="'${contentTemplatePath}'"
      dismissible="${dismissible}"
      scrollable="${scrollable}"
      template-data="vdSplashTemplateData">
   </vd-splash>`

/**
 * Provides a service for displaying a splash page in app.
 */
angular
  .module('vend.ui')
  .service(
    'vdSplashService',
    function ($q, $compile, $document, $timeout, vdModalsContainerService) {
      let deferred = null

      /**
       * Removes the vd-splash node element from the dom
       *
       * @private
       * @method _removeVdSplashElement
       */
      function _removeVdSplashElement() {
        const $vdSplashElement = $document[0].querySelector('vd-splash')

        if ($vdSplashElement) {
          angular.element($vdSplashElement).remove()

          // Remove class from body that prevents scrolling when splash is open
          const bodyNode = $document.find('body')
          bodyNode.removeClass(VD_CLASSES.noBodyScroll)
        }
      }

      /**
       * Displays the specified splash template by adding a vd-splash directive to the DOM
       *
       * @method openSplash
       *
       * @param  contentTemplatePath {String}
       *         The template cache path of the desired template to show within the splash page
       *
       * @param  scope {Object}
       *         The current angular scope required to compile the angular element to the DOM
       *
       * @param  [options] {Object}
       *
       *         @param [options.dismissible=false] {Boolean}
       *                Whether or not to display a close icon in the top right corner of the splash screen (also enables
       *                ESC key to close behaviour)
       *
       *         @param [options.templateData] {Any}
       *                Any data to pass to the splash content template. Accessible via vdSplashCtrl.templateData in the
       *                template.
       *
       * @return {Promise} Promise that resolves when splash is closed
       */
      this.openSplash = (contentTemplatePath, scope, options = {}) => {
        const dismissible = Boolean(options.dismissible)
        const scrollable = Boolean(options.scrollable)
        const vdSplashElementTemplate = renderSplashElement({
          contentTemplatePath,
          dismissible,
          scrollable,
        })

        deferred = $q.defer()

        if (options.templateData) {
          scope.vdSplashTemplateData = options.templateData
        }

        // Add the splash element dynamically to the DOM within the ng-app, use the supplied scope. Use timeout so changes
        // are applied by angular outside of any in progress digests.
        $timeout(() => {
          vdModalsContainerService
            .getModalsContainerElement()
            .append($compile(vdSplashElementTemplate)(scope))
        })

        return deferred.promise
      }

      /**
       * Hides and removes the vd-splash directive from the DOM
       *
       * @method closeSplash
       */
      this.closeSplash = () => {
        _removeVdSplashElement()

        if (deferred) {
          deferred.resolve()
          deferred = null
        }
      }
    }
  )
